import Button from 'antd/lib/button';
import Carousel from 'antd/lib/carousel';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Select from 'antd/lib/select';
import React, { useContext, useEffect, useState } from 'react';

import { axiosDeleteCall, axiosGetCall } from '../api/axiosCall';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import EyeOutlined from '@ant-design/icons/EyeOutlined';
import EditOutlined from '@ant-design/icons/EditOutlined';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';
import CommonLayout from '../common/CommonLayout';
import DataTable from '../common/DataTable';
import { getColumnSearchProps } from '../common/DataTableSearchTemplate';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../constant/constants';
import { AuthContext } from '../context/AuthProvider';
import AddProductModel from './Product/AddProductModel';
import EditProductModel from './Product/EditProductModel';
import ViewProductModel from './Product/ViewProductModel';

const { Option } = Select;

const TableHeader = ({ handleAddButtonClick }) => {
  return (
    <div className='flex-row justify-end flex'>
      <Button
        type='primary'
        icon={<PlusOutlined />}
        className='border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
        onClick={handleAddButtonClick}
      >
        Add Product
      </Button>
    </div>
  );
};

function Product() {
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModelOpen, setIsViewModelOpen] = useState(false);
  const [isEditModelOpen, setIsEditModelOpen] = useState(false);
  const [product, setProduct] = useState('');
  const [filteredProductList, setFilteredProductList] = useState([]);

  const [productCategoryList, setProductCategoryList] = useState([]);
  const [searchedText, setSearchedText] = useState('');
  const [filterText, setFilterText] = useState('');

  const { token } = useContext(AuthContext);

  useEffect(() => {
    getAllProduct();
    getCategoryList();
  }, []);

  useEffect(() => {
    handleSearchAndFilter();
  }, [searchedText, filterText]);

  async function getCategoryList() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_PRODUCT_CATEGORY_LIST,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        setProductCategoryList(res.data);
      } else {
        message.error(res.error.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  async function getAllProduct() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_ALL_PRODUCT,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        setProductList(res.data);
        setFilteredProductList(res.data);
        if (product) {
          res.data.forEach((item) => {
            if (item.productId === product.productId) {
              setProduct(item);
            }
          });
        }
      } else {
        message.error(SOMETHING_WENT_WRONG);
      }
      setIsLoading(false);
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  function handleAddButtonClick() {
    setIsModalOpen(!isModalOpen);
  }

  function handleAddModelClose() {
    setIsModalOpen(false);
  }

  function handleViewButtonClick(data) {
    setIsViewModelOpen(true);
    setProduct(data);
  }

  function handleViewModelCloseClick() {
    setIsViewModelOpen(false);
  }

  function handleEditButtonClick(data) {
    setIsEditModelOpen(true);
    const temp = JSON.parse(data.attribute);
    const keys = Object.keys(temp);
    const values = Object.values(temp);
    let xyz = { ...data };
    keys.map((item, index) => {
      xyz = {
        ...xyz,
        [`key_${index}`]: keys[index],
        [`value_${index}`]: values[index],
      };
    });
    setProduct(xyz);
  }

  function handleEditModelCloseClick() {
    setIsEditModelOpen(false);
  }

  async function handleDeleteProduct(record) {
    try {
      const res = await axiosDeleteCall({
        apiEndPoint: `${API_END_POINT.DELETE_PRODUCT}?ProductId=${record.productId}`,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        message.success(res.data.message);
        getAllProduct();
      } else {
        message.error(res.error.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  const columns = [
    {
      title: 'Image',
      render: (record) => {
        return (
          <div className='h-20 w-20'>
            <Carousel
              autoplay
              dots={false}
            >
              {record.productImages &&
                record.productImages.map((item, index) => (
                  <div key={index}>
                    <img
                      src={item.imagePath}
                      alt={`product_image_${index}`}
                      className='w-20 h-20 object-contain'
                    />
                  </div>
                ))}
            </Carousel>
          </div>
        );
      },
    },
    {
      key: 'productName',
      title: 'Product Name',
      dataIndex: 'productName',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => {
        if (a.productName) return a.productName.localeCompare(b.productName);
      },
      ...getColumnSearchProps('productName'),
    },
    {
      key: 'modelNo',
      title: 'Model No',
      dataIndex: 'modelNo',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => {
        if (a.modelNo) return a.modelNo.localeCompare(b.modelNo);
      },
      ...getColumnSearchProps('modelNo'),
    },
    {
      key: 'price',
      title: 'Prices',
      dataIndex: 'price',
      render: (e, record) => {
        return (
          <div className='flex flex-col'>
            <span>P1: {record.p1}</span>
            <span>P2: {record.p2}</span>
            <span>P3: {record.p3}</span>
            <span>R1: {record.r1}</span>
          </div>
        );
      },
    },
    {
      key: 'productCategoryName',
      title: 'Product Category',
      dataIndex: 'productCategoryName',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => {
        if (a.productCategoryName)
          return a.productCategoryName.localeCompare(b.productCategoryName);
      },
      ...getColumnSearchProps('productCategoryName'),
    },
    {
      title: 'Actions',
      render: (e, record) => (
        <div className='flex flex-col items-center gap-2'>
          <Button
            onClick={() => {
              handleViewButtonClick(record);
            }}
            className='border-primary text-primary'
            icon={<EyeOutlined />}
          >
            View
          </Button>
          <Button
            onClick={() => {
              handleEditButtonClick(record);
            }}
            type='primary'
            className='border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popconfirm
            title='Are you Sure to Delete?'
            onConfirm={() => handleDeleteProduct(record)}
            okType='default'
          >
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => {}}
            >
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  function handleSearchAndFilter() {
    if (searchedText && filterText) {
      const data = productList.filter((item) => {
        if (
          item.productName.toLowerCase().includes(searchedText.toLowerCase()) &&
          item.productCategoryName
            .toLowerCase()
            .includes(filterText.toLowerCase())
        ) {
          return item;
        }
      });
      setFilteredProductList(data);
    } else if (searchedText) {
      const data = productList.filter((item) => {
        if (
          item.productName.toLowerCase().includes(searchedText.toLowerCase())
        ) {
          return item;
        }
      });
      setFilteredProductList(data);
    } else if (filterText) {
      const data = productList.filter((item) => {
        if (
          item.productCategoryName
            .toLowerCase()
            .includes(filterText.toLowerCase())
        ) {
          return item;
        }
      });
      setFilteredProductList(data);
    } else {
      setFilteredProductList(productList);
    }
  }

  const handleProductSearch = (input) => {
    setSearchedText(input.target.value);
  };

  const handleProductCategoryChange = (value) => {
    setFilterText(value);
  };

  return (
    <CommonLayout>
      <div className='flex flex-col items-stretch'>
        <div className='w-full flex-row flex justify-between'>
          <Input
            placeholder='Search Product'
            style={{ width: '40%', marginTop: '5px' }}
            onChange={(value) => {
              handleProductSearch(value);
            }}
          />
          <Select
            placeholder='Select a Product Category'
            style={{ width: '40%', paddingTop: '5px' }}
            size='large'
            allowClear
            onChange={(value) => {
              handleProductCategoryChange(value);
            }}
            onClear={() => {
              setFilteredProductList(productList);
            }}
            showSearch
          >
            {productCategoryList.map((category) => (
              <Option
                key={category.productCategoryId}
                value={category.categoryName}
              >
                {category.categoryName}
              </Option>
            ))}
          </Select>
        </div>
        <DataTable
          title={<TableHeader handleAddButtonClick={handleAddButtonClick} />}
          isTableRowEditable={false}
          data={filteredProductList}
          columns={columns}
          isSpinning={isLoading}
          rowKey='productId'
        />
        <ViewProductModel
          isOpen={isViewModelOpen}
          product={product}
          handleViewModelCloseClick={handleViewModelCloseClick}
        />
        <AddProductModel
          isOpen={isModalOpen}
          callback={getAllProduct}
          handleAddModelClose={handleAddModelClose}
        />
        {isEditModelOpen && (
          <EditProductModel
            isOpen={isEditModelOpen}
            product={product}
            callback={getAllProduct}
            handleEditModelCloseClick={handleEditModelCloseClick}
            getAllProduct={getAllProduct}
          />
        )}
      </div>
    </CommonLayout>
  );
}

export default Product;
